import Image from 'next/image';

import styles from './InternetActivation.module.scss';

const Step = ({ step }) => {
  return (
    <div
      className={styles.step}
      itemScope
      itemType='http://schema.org/HowToStep'
    >
      <div
        className={styles.title}
        dangerouslySetInnerHTML={{ __html: step?.title }}
      ></div>
      <div className={styles.image}>
        <div className={styles.imageWrapper}>
          <Image
            src={step?.image}
            className={styles.img}
            alt={step?.title}
            title={step?.title}
            loading='lazy'
            layout='fill'
          />
        </div>
      </div>
    </div>
  );
};

export default Step;
